import React, { useEffect } from "react";
import axiosInstance from "../config/axios";
import { emitApsReviewSeen } from "../utils/apsReviewEvents";
import ApsReviewPanel from "./ApsReviewPanel";

const ApsReviewModal = ({
  tradeId,
  tradeNumber,
  listingId,
  listingNumber,
  onClose,
}) => {
  useEffect(() => {
    if (listingId) {
      emitApsReviewSeen({ listingId: String(listingId) });
      axiosInstance
        .patch(`/listing-documents/${listingId}/document-review/seen`)
        .catch(() => {});
      return;
    }
    if (!tradeId) return;
    emitApsReviewSeen({ tradeId: String(tradeId) });
    axiosInstance
      .patch(`/trade-documents/${tradeId}/aps-review/seen`)
      .catch(() => {});
  }, [tradeId, listingId]);

  if (!tradeId && !listingId) return null;
  const title = listingId
    ? `Compliance Review${listingNumber ? ` — Listing #${listingNumber}` : ""}`
    : `Compliance Review${tradeNumber ? ` — Trade #${tradeNumber}` : ""}`;
  return (
    <div className="fixed inset-0 z-[80] flex items-start justify-center bg-black/50 overflow-y-auto py-8 px-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full relative">
        <div className="flex items-center justify-between px-5 py-3 border-b">
          <h2 className="text-lg font-semibold text-blue-900">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            className="text-2xl leading-none text-gray-500 hover:text-gray-800 px-2"
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className="p-2">
          <ApsReviewPanel tradeId={tradeId} listingId={listingId} />
        </div>
      </div>
    </div>
  );
};

export default ApsReviewModal;
